var App = App || {};

App.CdsSelect = (function ($) {
    'use strict';

    function init() {

        $(".component-cdsSelect").each(function () {

            const form = $(this).find("form");
            const select = form.find("select");
            const button = form.find("a.btn");
            const hrefDisabled = button.attr("href")

            select.on("input", function () {

                const value = $(this).val();

                if (value == "") {
                    button.addClass("disabled");
                    button.attr("href", hrefDisabled);
                }
                else {
                    button.removeClass("disabled");
                    button.attr("href", `#open-account-cd?productId=${value}`);
                }
            });

        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.CdsSelect.init();
});